// Piezas compartidas de la PAUSA de mensajes automáticos (F3, 9-sep-2026): las usan la
// tarjeta de la página de WhatsApp y el banner global, que si no dirían cosas distintas
// de la misma pausa. Espejo del `waPauseService.ts` de la agenda dental.
import whatsappApi, { type WaPauseState } from '../../api/whatsappApi';

/** Evento propio: quien cambie la pausa lo dispara y el banner se entera sin recargar. */
export const WA_PAUSE_EVENT = 'wa-pause-changed';
export const notifyWaPauseChanged = () => window.dispatchEvent(new Event(WA_PAUSE_EVENT));

export const PAUSE_OFF: WaPauseState = { activa: false, level: 0, until: null };

/** Ante cualquier fallo, "sin pausa": un error de red no debe pintar un banner falso. */
export async function leerPausa(): Promise<WaPauseState> {
  try {
    const d = await whatsappApi.getPause();
    return d?.activa ? d : PAUSE_OFF;
  } catch {
    return PAUSE_OFF;
  }
}

/** "hasta las 6:12 p.m." — hora local del navegador, que es la del negocio. */
export function hastaTexto(until: string | null): string {
  if (!until) return '';
  const d = new Date(until);
  if (Number.isNaN(d.getTime())) return '';
  const hoy = new Date().toDateString() === d.toDateString();
  const hora = d.toLocaleTimeString('es-MX', { hour: 'numeric', minute: '2-digit', hour12: true });
  return hoy ? `hasta las ${hora}` : `hasta mañana a las ${hora}`;
}

export const DURACIONES: { label: string; minutes: number }[] = [
  { label: '1 hora', minutes: 60 },
  { label: '4 horas', minutes: 240 },
  { label: '24 horas', minutes: 1440 },
];

export type { WaPauseState };
